// extracted by mini-css-extract-plugin
export default {"Wrapper":"NotFound_Wrapper__673KI","NotFoundIcon":"NotFound_NotFoundIcon__+co9U","Text":"NotFound_Text__DycG9"};